import React, { forwardRef } from 'react';
import * as RadixAccordion from '@radix-ui/react-accordion';

type AccordionItemProps = React.ComponentPropsWithoutRef<typeof RadixAccordion.Item>;

const AccordionItem = forwardRef<React.ElementRef<typeof RadixAccordion.Item>, AccordionItemProps>(
  ({ children, className, ...rest }, ref) => (
    <RadixAccordion.Item ref={ref} className={className} {...rest}>
      {children}
    </RadixAccordion.Item>
  )
);

const Item = AccordionItem;

export { type AccordionItemProps, AccordionItem, Item };
